import { ShoppingListIngredientDetail } from "@/clients/models/ShoppingListIngredientDetail";
import { useSearchParams } from "@/hooks/router/use-search-params";
import { cn } from "@/utils/cn";
import { IonBadge, useIonRouter } from "@ionic/react";
import { memo, useMemo } from "react";
import { useLocation } from "react-router";
import { getAisleIcon } from "../../utils/shopping-list-helpers";

interface AisleFilterTabButtonProps {
  aisle: string;
  isActive: boolean;
  ingredients: ShoppingListIngredientDetail[];
}

const AisleFilterTabButton = memo(function AisleFilterTabButton({
  aisle,
  isActive,
  ingredients,
}: AisleFilterTabButtonProps) {
  const searchParams = useSearchParams();
  const location = useLocation();
  const navigate = useIonRouter();
  const unTickedCount = useMemo(
    () => ingredients.filter((ingredient) => !ingredient.isTicked).length,
    [ingredients],
  );

  const navigateToTab = (aisle: string) => {
    searchParams.set("aisle", aisle);
    navigate.push(`${location.pathname}?${searchParams.toString()}`);
  };
  return (
    <button
      key={aisle}
      className={cn(
        "h-10 px-2 py-1 flex-shrink-0",
        "flex items-center gap-2 rounded-md transition-all duration-200 whitespace-nowrap",
        "text-sm font-medium relative",
        {
          "bg-secondary-light": isActive,
          "bg-gray-100": !isActive,
        },
      )}
      onClick={() => navigateToTab(aisle)}
    >
      <span className="text-lg">{getAisleIcon(aisle)}</span>
      <span>{aisle}</span>
      {unTickedCount > 0 && (
        <div className="absolute right-0 top-1 translate-x-1/2 -translate-y-1/2 z-10">
          <IonBadge slot="start" color="tertiary" className="text-xs px-2">
            {unTickedCount}
          </IonBadge>
        </div>
      )}
    </button>
  );
});

export default AisleFilterTabButton;
